module.exports = __webpack_public_path__ + "img/tailIco.0a9abed9.svg";